import { z } from 'zod';
import { DemoConfigSchema } from './demo';
// Template Types
export const TemplateSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    category: z.string(),
    tags: z.array(z.string()),
    businessDomain: z.string(),
    useCase: z.string(),
    difficulty: z.enum(['beginner', 'intermediate', 'advanced']),
    estimatedSetupTime: z.number(), // in minutes
    demoConfig: DemoConfigSchema.omit({ id: true, userId: true, createdAt: true, updatedAt: true }),
    customizationOptions: z.array(z.object({
        key: z.string(),
        label: z.string(),
        type: z.enum(['text', 'select', 'boolean', 'number', 'color']),
        defaultValue: z.any(),
        options: z.array(z.string()).optional(),
        required: z.boolean(),
        description: z.string(),
    })),
    previewImages: z.array(z.string()),
    isPublic: z.boolean(),
    authorId: z.string(),
    version: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// Template Generation
export const GeneratedDemoSchema = z.object({
    title: z.string(),
    description: z.string(),
    businessDomain: z.string(),
    agents: z.array(z.object({
        name: z.string(),
        role: z.string(),
        expertise: z.array(z.string()),
        personality: z.string(),
        dataSources: z.array(z.string()),
        bedrockModel: z.string(),
        instructions: z.string(),
    })),
    scenarios: z.array(z.object({
        title: z.string(),
        description: z.string(),
        exampleQueries: z.array(z.string()),
    })),
    suggestedUIConfig: z.object({
        theme: z.object({
            primaryColor: z.string(),
            secondaryColor: z.string(),
        }),
        branding: z.object({
            companyName: z.string(),
            tagline: z.string().optional(),
        }),
    }),
});
// Validation Results
export const ValidationResultSchema = z.object({
    isValid: z.boolean(),
    errors: z.array(z.object({
        field: z.string(),
        message: z.string(),
        severity: z.enum(['error', 'warning', 'info']),
    })),
    warnings: z.array(z.object({
        field: z.string(),
        message: z.string(),
        suggestion: z.string().optional(),
    })),
});
//# sourceMappingURL=template.js.map